import { render, staticRenderFns } from "./ActivationCode.vue?vue&type=template&id=6f9c2b6a&scoped=true&"
import script from "./ActivationCode.vue?vue&type=script&lang=js&"
export * from "./ActivationCode.vue?vue&type=script&lang=js&"
import style0 from "./ActivationCode.vue?vue&type=style&index=0&id=6f9c2b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c2b6a",
  null
  
)

export default component.exports